import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaClock, FaArrowRight, FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import "./Careers.css";

const Careers = () => {
  const [searchQuery, setSearchQuery] = useState("");

  // List of open job positions
  const jobs = [
    {
      id: 1,
      title: "Android Developer",
      category: "MOBILE DEVELOPMENT",
      location: "Karnataka, Andhra Pradesh, Telangana (Remote)",
      posted: "2 days ago"
    },
    
    
    
  ];

  // Filter jobs based on search query
  const filteredJobs = jobs.filter(
    (job) =>
      job.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      job.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
      job.location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="careers-container">
      {/* Hero Section */}
      <div
        className="hero-section"
        style={{
          backgroundImage: `url("https://res.cloudinary.com/dy8shu8ss/image/upload/v1738138405/pexels-andrew-3178818_1_sy6cpt.jpg")`,
        }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">Find the Right Fit & Ace It</h1>
          <p className="hero-subtitle">
            JJoin our team of passionate innovators and smart problem solvers.
          </p>
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search here for role, category, location"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="search-button">SEARCH</button>
          </div>
        </div>
      </div>

      {/* Job Listings Section */}
      <div className="careers-content">
        <h2 className="jobs-title">List of Opportunities</h2>
        <p className="jobs-subtitle">
          Find the best selection to kickstart your career
        </p>

        <div className="job-cards">
          {filteredJobs.map((job) => (
            <Link to={`/job/${job.id}`} key={job.id} className="job-card">
              <div className="job-card-content">
                <h1 className="job-title">{job.title}</h1>
                <p className="job-category">{job.category}</p>
                <div className="job-location">
                  <FaMapMarkerAlt className="location-icon" />
                  <span>{job.location}</span>
                </div>
                <div className="job-posted">
                  <FaClock className="clock-icon" />
                  <span>Posted 2 days ago</span>
                </div>
                <div className="job-link">
                  Learn More <FaArrowRight className="link-icon" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Footer Section */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>Vero Disruptors is a leading innovator in data-driven solutions, providing cutting-edge services to help businesses grow and succeed.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/products">Products</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/careers">Careers</a></li>
              <li><a href="/contactus">Contact Us</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href="https://www.facebook.com/share/1AF81Af26p/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
              
              <a href="https://www.linkedin.com/company/vero-disruptors-pvt-ltd/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              
            </div>
            
          </div>
          
        </div>
        <div className="footer-legal-links">
        
        <a href="/contactus">Contact Us</a>
        <a href="/terms">Term Of Use</a>
        <a href="/privacy">Privacy Statement</a>
        <a href="/refund">            Refund Policy
      </a>
        <a href="/about">About Us</a>
      
      </div>
      
        <div className="contactus-footer">
          <p>Copyright © Vero Disruptors {new Date().getFullYear()}. All rights reserved.</p>
        </div>
      </footer>
      
    </div>
  );
};

export default Careers;